import * as React from 'react';
import { useMemo } from 'react';
import { AdditionalTravellerFieldEnum, InputType } from '../../../../Passenger/types';
import { TravellerFieldEnum } from '@websky/graphql';
import Group from './Group/Group';
import { useTheme } from '../../../../theme';
import { getGroupIcon, getGroupsMap } from './utils';
import { useRenderers } from '../../../../renderProps';
import Accompanying from './Group/Accompanying/Accompanying';
const FormFields = props => {
    const theme = useTheme('PassengerForm').FormFields;
    const { PassengerFormGroup: PassengerFormGroupOverride = Group } = useRenderers();
    const { fieldGroups, birthDateField } = useMemo(() => {
        const fields = [
            ...props.fields,
            { name: 'disability', type: AdditionalTravellerFieldEnum.Disability, input: InputType.Switch }
        ];
        return {
            fieldGroups: getGroupsMap(fields, props.passengerId, props.isChangePassengers),
            birthDateField: fields.find(field => field.type === TravellerFieldEnum.BirthDate)
        };
    }, [props.fields, props.isChangePassengers]);
    const docExpiryDateField = React.useMemo(() => props.fields.find(field => field.type === TravellerFieldEnum.DocExpiryDate), [props.fields]);
    return (React.createElement("div", null,
        !props.inline && React.createElement("div", { className: theme.label }, props.label),
        React.createElement("div", { className: theme.container }, fieldGroups.map((group, index) => {
            return (React.createElement(PassengerFormGroupOverride, { key: group.type, fields: group.fields, groupType: group.type, passengerId: props.passengerId, passengerType: props.passengerType, passengerDocType: props.passengerDocType, disabled: props.disabled, onTravellerSelect: props.onTravellerSelect, isAuthorized: props.isAuthorized, autofocus: props.autofocus && index === 0, onSignUpLoyaltyProgram: props.onSignUpLoyaltyProgram, groupIcon: props.showGroupIcons && getGroupIcon(group.type), selectedProfileId: props.selectedProfileId, isChangeFiles: props.isChangeFiles, onSwap: props.onSwap, onToggleChangeFiles: props.onToggleChangeFiles, docExpiryDateField: docExpiryDateField, birthDateField: birthDateField }));
        })),
        React.createElement(Accompanying, { passengerId: props.passengerId, passengerType: props.passengerType, disabled: props.disabled, accompanyingFields: props.accompanyingFields })));
};
export default FormFields;
